export default {
  name: 'marking--aggrH',
  apiService: 'shoes',
  apiPath: '/admin/aggr_h',
};